import { render, staticRenderFns } from "./EditLearningHub.vue?vue&type=template&id=778c0b76"
import script from "./EditLearningHub.vue?vue&type=script&lang=js"
export * from "./EditLearningHub.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports